import { inject, Injectable } from '@angular/core';

import { ConsoleService } from './console.service';
import { LogEvent, LogLevel, LogTargetBase } from './log.target';

@Injectable()
export class ConsoleTarget extends LogTargetBase {
  private console = inject(ConsoleService);

  writeToLog(event: LogEvent) {
    const data: unknown[] = Array.isArray(event.message) ? event.message : [event.message];

    switch (event.level) {
      case LogLevel.Debug:
        this.console.debug(...data);
        break;
      case LogLevel.Info:
        this.console.info(...data);
        break;
      case LogLevel.Warning:
        this.console.warn(...data);
        break;
      case LogLevel.Error:
        this.console.error(event.message, event.context, event.error);
        break;
    }
    return Promise.resolve();
  }
}
